import React from 'react'

const Step_seven = ({ prevStep, nextStep }) => {
    return (
        <>
            <section className='quizformsection'>

                <div className='navigationdiv'>
                    <div className='row'>
                        <div className='col-12 text-center'>
                            <p className='formstepps'>07/07</p>
                        </div>
                        <div className='col-12 text-center'>
                            <div className='formtitlediv'>
                                <h2 className='formtitle'>Which shapes do you like?</h2>
                                <button className="backbtn" type="button" onClick={prevStep} >
                                    <img className='backicon' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/backbtn.png'} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='productsdiv'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-4 col-sm-6  mb-3'>
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/gog1.png'} />
                                    </div>
                                    <p className='prodname'>Square</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-6  mb-3'>
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/gog2.png'} />
                                    </div>
                                    <p className='prodname'>Round</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-sm-6  mb-3'>
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/gog3.png'} />
                                    </div>
                                    <p className='prodname'>Rectangle</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-sm-6  mb-3'>
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/gog4.png'} />
                                    </div>
                                    <p className='prodname'>Cat-eye</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-sm-6  mb-3'>
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/gog5.png'} />
                                    </div>
                                    <p className='prodname'>Aviator</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='nextbuttondiv'>
                    <button className='nextbtn' onClick={nextStep}>No preference</button>
                </div>


            </section>
        </>
    )
}

export default Step_seven